import { useEffect, useState } from "react";

/**
 * OAuth callback component that handles the OAuth redirect
 */
export const OAuthCallback = () => {
	const [hasError, setHasError] = useState(false);
	const [isProcessing, setIsProcessing] = useState(true);

	useEffect(() => {
		console.log("[OAuthCallback] Component mounted");

		const handleCallback = async () => {
			const url = new URL(window.location.href);
			const code = url.searchParams.get("code");
			const errorParam = url.searchParams.get("error");

			console.log("[OAuthCallback] Checking URL params", {
				hasCode: !!code,
				hasError: !!errorParam,
				error: errorParam,
				url: window.location.href,
			});

			if (errorParam) {
				console.error("[OAuthCallback] Error in URL params:", errorParam);

				// Show error message
				setHasError(true);
				setIsProcessing(false);
				return;
			}

			if (!code) {
				console.error("[OAuthCallback] No authorization code received");
				setHasError(true);
				setIsProcessing(false);
				return;
			}

			// The CustomAuthProvider's onPageLoad method will handle the actual callback
			// This component just provides UI feedback
			console.log(
				"[OAuthCallback] Code received, waiting for auth provider to process",
			);
			setIsProcessing(true);
		};

		handleCallback();
	}, []);

	if (hasError) {
		return (
			<div className="p-8 text-center">
				<p className="text-sm text-gray-700 my-4">
					Your organization onboarding is incomplete.<br/>
					Please contact <a href="mailto:support@beamconnectivity.com">support@beamconnectivity.com</a> to
					setup your organisation and complete developer onboarding.
				</p>
				<button type="button" onClick={() => { window.location.href = "/"; }}>
					Return to Home
				</button>
			</div>
		);
	}

	// Otherwise just show "Completing authentication..."
	return (
		<div className="p-8 text-center">
			<h2>Completing authentication...</h2>
		</div>
	);
};
